// extracted by mini-css-extract-plugin
var _1 = "RequestProfileTabRatingCard-modulecard__lupnG";
var _2 = "RequestProfileTabRatingCard-moduledivider__TCV8E Divider-moduleDivider__dL3Vg";
export { _1 as "card", _2 as "divider" }
